export const HOMEPAGE_DATA_LOAD = 'homepage/DATA_LOAD'
